import React, { useEffect, useState } from 'react';
import { PrimaryButton } from '../ui/Primitives.jsx';
import { currencyForLanguage } from '../../lib/pricing.js';

// ============================================================================
// Ponte pro pagamento de verdade — criado em 16/09/2026 junto com o funil
// web (Stripe), depois da conta já existir (ver AccountScreen.jsx). Chama
// a Netlify Function create-checkout-session.js, que devolve a URL da
// página de pagamento hospedada pelo próprio Stripe (Stripe Checkout) —
// não construímos formulário de cartão aqui (nunca deveríamos guardar
// número de cartão nós mesmos; o Stripe Checkout já resolve isso com
// segurança PCI de verdade).
// ============================================================================
export default function CheckoutScreen({ planId, email, userId, onCancel }) {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  // Botão "voltar" do navegador (ex: iPhone/Safari) restaura esta página
  // congelada na tela de "te levando pro pagamento..." — sem isso fica
  // girando pra sempre. Ao reaparecer vinda do histórico, volta pros planos.
  useEffect(() => {
    const onShow = (e) => {
      if (e.persisted) onCancel();
    };
    window.addEventListener('pageshow', onShow);
    return () => window.removeEventListener('pageshow', onShow);
  }, [onCancel]);

  useEffect(() => {
    let cancelled = false;
    async function start() {
      setLoading(true);
      setError('');
      try {
        const res = await fetch('/.netlify/functions/create-checkout-session', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ planId, email, userId, currency: currencyForLanguage() }),
        });
        const data = await res.json();
        if (!res.ok || !data.url) throw new Error(data.message || 'Não deu pra iniciar o pagamento.');
        if (!cancelled) window.location.href = data.url;
      } catch (err) {
        if (!cancelled) {
          setError(err?.message || 'Algo deu errado. Tenta de novo em instantes.');
          setLoading(false);
        }
      }
    }
    start();
    return () => {
      cancelled = true;
    };
  }, [planId, email, userId]);

  return (
    <div className="phone-frame flex flex-col items-center justify-center safe-top safe-bottom px-6 text-center">
      {loading && !error && (
        <>
          <div className="w-10 h-10 border-2 border-cyan border-t-transparent rounded-full animate-spin mb-6" />
          <p className="text-ink-muted">Te levando pro pagamento seguro...</p>
        </>
      )}
      {!!error && (
        <>
          <p className="text-red-400 mb-6">{error}</p>
          <PrimaryButton onClick={onCancel}>Voltar</PrimaryButton>
        </>
      )}
    </div>
  );
}
